import { EvmAddressSummaryInfo, EvmTokenSummaryInfo } from '~/api/repository'
import ADT = EvmAddressSummaryInfo.ADT;
import { IMAGE_BASE_URL } from '~/constants/image.constant'
import { ICommonSummaryInfo } from '~/types/common.type'
import { tokenType } from '~/types/token-type.type'

export class CommonSummaryModel {
  protected readonly name: string
  protected readonly address: string
  protected readonly symbol: string

  constructor(data: ICommonSummaryInfo) {
    this.name = data.name
    this.address = data.address
    this.symbol = data.symbol
  }
}

export class AddressSummaryModel extends CommonSummaryModel {
  readonly addressType: ADT

  constructor(data: EvmAddressSummaryInfo) {
    super({
      name: data.NN,
      address: data.ADDR,
      symbol: data.SB
    })
    this.addressType = data.ADT
  }

}

export class TokenSummaryModel extends CommonSummaryModel {
  readonly image: string

  constructor(data: EvmTokenSummaryInfo, tokenType?: tokenType) {
    super({
      name: data.NN || tokenType || 'N/A',
      address: data.ADDR,
      symbol: data.SB
    })
    this.image = data.IMG || IMAGE_BASE_URL + '/token/default.png'
  }
}